var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49609 2.90234H16.6707",
    stroke: "#C51F2A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72656 1.83203H11.2114",
    stroke: "#C51F2A",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.37109 5.31641H15.5681V18.9982C15.5681 20.1028 14.6726 20.9982 13.5681 20.9982H5.3711C4.26653 20.9982 3.37109 20.1028 3.37109 18.9982V5.31641ZM6.76124 15.6943C6.46834 15.4014 6.46834 14.9265 6.76124 14.6336L8.54105 12.8538L6.76122 11.074C6.46833 10.7811 6.46833 10.3062 6.76122 10.0133C7.05411 9.72045 7.52899 9.72045 7.82188 10.0133L9.60171 11.7932L11.3815 10.0133C11.6744 9.72045 12.1493 9.72045 12.4422 10.0133C12.7351 10.3062 12.7351 10.7811 12.4422 11.074L10.6624 12.8538L12.4422 14.6336C12.7351 14.9265 12.7351 15.4014 12.4422 15.6943C12.1493 15.9872 11.6744 15.9872 11.3815 15.6943L9.60171 13.9145L7.8219 15.6943C7.529 15.9872 7.05413 15.9872 6.76124 15.6943Z",
    fill: "#C51F2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/IconTrash.011863b5324e949b89e71d83417bc371.svg";
export { ForwardRef as ReactComponent };